import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import DocsExample from '@/components/DocsExample'
import axios from 'axios'
import moment from 'moment'

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      store.dispatch('logout')
      return router.push('/auth/login')
    }
  }
})

if (localStorage.getItem('apiToken')) {
  store.commit('setToken', localStorage.getItem('apiToken'))
}

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(moment)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
app.component('DocsExample', DocsExample)

app.mount('#app')
